module.exports = __webpack_public_path__ + "static/media/snowshoes.3c226952.webp";